// src/components/ui/TokenBalanceChip.tsx
import React from 'react';

interface Props {
  balance: number;
  className?: string;
}

export function TokenBalanceChip({ balance, className = '' }: Props) {
  const color = balance === 0
    ? 'bg-red-100 text-red-700 border-red-200'
    : balance < 20
      ? 'bg-amber-100 text-amber-700 border-amber-200'
      : 'bg-green-100 text-green-700 border-green-200';

  const icon = balance === 0 ? '⚠' : balance < 20 ? '⚡' : '◎';

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs rounded-full px-2.5 py-1 border font-medium ${color} ${className}`}
      title={`Token balance: ${balance}`}
    >
      <span>{icon}</span>
      <span>{balance.toLocaleString()} tokens</span>
    </span>
  );
}
